<template>
  <div id="adminDashboardComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <b-row class="mb-4">
        <b-col class="text-right">
          <b-form-group class="my-0">
            <b-form-radio-group
              button-variant="outline-primary"
              id="btn-radios-1"
              v-model="filterValue"
              :options="filterOptions"
              buttons
              name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content" style="background-color: #F8E9A1;">
            <div class="widget-content-wrapper text-gray">
              <div class="widget-content-left">
                <div class="widget-heading">{{$t('dashboard.loaded')}}</div>
                <div class="widget-subheading">{{$t('dashboard.' + filterSelected)}}:</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-gray" v-if="loadingTotalExpenses">
                  <v-progress-circular indeterminate size="30"></v-progress-circular>
                </div>
                <div class="widget-numbers text-gray" v-else>{{totalExpenses.size}}</div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content" style="background-color: #D8E8F8;">
            <div class="widget-content-wrapper text-gray">
              <div class="widget-content-left">
                <div class="widget-heading">{{$t('dashboard.amount')}}</div>
                <div class="widget-subheading">{{$t('dashboard.' + filterSelected)}}:</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-gray" v-if="loadingByAmount">
                  <v-progress-circular indeterminate size="30"></v-progress-circular>
                </div>
                <div class="widget-numbers text-gray" :class="getFontSizeClass(byAmount.total)" v-else>{{byAmount.total | formatCurrency}}</div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content" style="background-color: #B2E8D1 !important;">
            <div class="widget-content-wrapper text-gray">
              <div class="widget-content-left">
                <div class="widget-heading">{{$t('general.paid')}}</div>
                <div class="widget-subheading">{{$t('dashboard.' + filterSelected)}}:</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-gray" v-if="loadingPayables">
                  <v-progress-circular indeterminate size="30"></v-progress-circular>
                </div>
                <div class="widget-numbers text-gray" v-else>{{payables.size}}</div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content" style="background-color: #F4C7C3;">
            <div class="widget-content-wrapper text-gray">
              <div class="widget-content-left">
                <div class="widget-heading">{{$t('general.rejected')}}</div>
                <div class="widget-subheading">{{$t('dashboard.' + filterSelected)}}:</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-gray" v-if="loadingRejecteds">
                  <v-progress-circular indeterminate size="30"></v-progress-circular>
                </div>
                <div class="widget-numbers text-gray" v-else>{{rejecteds.size}}</div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <v-divider class="my-5"></v-divider>
      <b-row class="mb-3">
        <b-col>
          <h1 class="primary--text font-weight-bold">{{$t('dashboard.paidByType')}}:</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col col-md-12 col-xs-12>
          <div class="p-1 slick-slider-xl mx-auto">
            <div class="text-center my-4" v-if="loadingCategoriesAmount">
              <v-progress-circular color="grey" indeterminate size="50"></v-progress-circular>
            </div>
            <slick ref="slick" :options="slickOptions" v-else>
              <b-col v-for="(item, index) in categoriesAmount" :key="item.id">
                <b-card class="mb-3 widget-chart">
                  <div class="widget-chart-content">
                    <div class="icon-wrapper rounded">
                      <div class="icon-wrapper-bg" :class="'bg-' + getColorByIndex(index)"></div>
                      <i :class="'text-' + getColorByIndex(index) + ' ' + 'lnr-star'"></i>
                    </div>
                  </div>
                  <div class="widget-subheading mt-2 mb-3 fsize-1 pt-2 opacity-10 font-weight-bold" :class="'text-' + getColorByIndex(index)">{{item.name}}</div>
                  <div class="widget-numbers my-0">
                    <span>{{item.total ? item.total : 0 | formatCurrency}}</span>
                  </div>
                  <div class="widget-chart-wrapper">
                  </div>
                </b-card>
              </b-col>
            </slick>
          </div>
        </b-col>
      </b-row>
      <v-divider class="mb-5"></v-divider>
      <b-row class="mb-3">
        <b-col cols="8">
          <h1 class="primary--text font-weight-bold">{{$t('dashboard.amountPaid')}}:</h1>
        </b-col>
        <b-col cols="4">
          <h1 class="primary--text font-weight-bold">{{$t('dashboard.paidType')}}:</h1>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="8">
          <b-card class="widget-chart widget-chart2 text-left p-0 align-items-start" style="min-height: 280px">
            <div class="widget-chat-wrapper-outer">
              <div class="text-center pt-5 mt-5" v-if="loadingPayables">
                <v-progress-circular color="grey" indeterminate size="70"></v-progress-circular>
              </div>
              <div class="widget-chart-wrapper he-auto opacity-10 m-0 position-absolute" v-else>
                <apexchart height="250" type="area" :options="chartOptions2" :series="series2"></apexchart>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card class="widget-chart widget-chart2 text-left p-0 align-items-start" style="min-height: 280px">
            <div class="widget-chat-wrapper-outer">
                <div class="text-center pt-5 mt-5" v-if="loadingCategoriesAmount">
                  <v-progress-circular color="grey" indeterminate size="70"></v-progress-circular>
                </div>
                <div class="opacity-10 position-absolute"  v-else>
                  <apexchart style="padding-left: 15%;" height="300" type="donut" :options="chartOptions3" :series="series3" v-if="chartOptions3Colors.length > 0"></apexchart>
                </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- <v-divider class="my-5"></v-divider>
      <b-row class="mb-3">
        <b-col>
          <h1 class="primary--text font-weight-bold">{{$t('general.expenses')}}</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col md-6 lg-3>
          <b-card class="widget-chart widget-chart2 text-left card-btm-border card-shadow-success border-success">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content">
                <div class="widget-title opacity-5 text-uppercase">{{$t('general.paid')}}</div>
                <div class="widget-numbers mt-2 fsize-4 mb-0 w-100">
                  <div class="widget-chart-flex align-items-center">
                    <div v-if="loadingPayables">
                      <v-progress-circular color="grey" indeterminate></v-progress-circular>
                    </div>
                    <div v-else>
                      {{payables.size}}
                      <small class="opacity-5 pl-1">{{$t('dashboard.expenses')}}</small>
                    </div>
                    <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted">
                      <div class="icon-wrapper rounded-circle">
                        <div class="icon-wrapper-bg opacity-10 bg-success"></div>
                        <i class="lnr-checkmark-circle text-white opacity-10"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md-6 lg-3>
          <b-card class="widget-chart widget-chart2 text-left card-btm-border card-shadow-warning border-warning">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content">
                <div class="widget-title opacity-5 text-uppercase">{{$t('general.payable')}}</div>
                <div class="widget-numbers mt-2 fsize-4 mb-0 w-100">
                  <div class="widget-chart-flex align-items-center">
                    <div v-if="loadingPayables">
                      <v-progress-circular color="grey" indeterminate></v-progress-circular>
                    </div>
                    <div v-else>
                      {{payables.size}}
                      <small class="opacity-5 pl-1">{{$t('dashboard.expenses')}}</small>
                    </div>
                    <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted">
                      <div class="icon-wrapper rounded-circle">
                        <div class="icon-wrapper-bg opacity-10 bg-warning"></div>
                        <i class="lnr-clock text-white opacity-10"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md-6 lg-3>
          <b-card class="widget-chart widget-chart2 text-left card-btm-border card-shadow-danger border-danger">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content">
                <div class="widget-title opacity-5 text-uppercase">{{$t('general.rejected')}}</div>
                <div class="widget-numbers mt-2 fsize-4 mb-0 w-100">
                  <div class="widget-chart-flex align-items-center">
                    <div v-if="loadingRejecteds">
                      <v-progress-circular color="grey" indeterminate></v-progress-circular>
                    </div>
                    <div v-else>
                      {{rejecteds.size}}
                      <small class="opacity-5 pl-1">{{$t('dashboard.expenses')}}</small>
                    </div>
                    <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted">
                      <div class="icon-wrapper rounded-circle">
                        <div class="icon-wrapper-bg opacity-10 bg-danger"></div>
                        <i class="lnr-cross-circle text-white opacity-10"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row> -->
      <v-divider class="my-5"></v-divider>
      <b-row class="mb-3">
        <b-col>
          <h1 class="primary--text font-weight-bold">{{$t('dashboard.expenseByProject')}}</h1>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col xs-12 md-12>
          <v-layout class="ma-2" row wrap>
            <v-pagination
              v-if="projectsPages > 0"
              v-model="page"
              :length="projectsPages"
              circle
            ></v-pagination>
            <v-spacer/>
            <v-select
              v-model="projectsToShow"
              :items="projectsPerPage"
              item-text="text"
              item-value="value"
              :label="$t('dashboard.projectsPerPage')"
            ></v-select>
          </v-layout>
          <b-card class="widget-chart widget-chart2 text-left p-0 align-items-start" style="min-height: 280px">
            <div class="widget-chat-wrapper-outer">
              <div class="mt-5 pt-5 text-center" v-if="loadingProjects">
                <v-progress-circular color="grey" indeterminate size="70"></v-progress-circular>
              </div>
              <div class="widget-chart-wrapper he-auto opacity-10 m-0 position-absolute" v-else>
                <apexchart height="250" type="area" :options="chartOptions" :series="projectsSeries"></apexchart>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </v-container>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'adminDashboadComponent',
  components: {
    Slick,
    'apexchart': VueApexCharts
  },
  data () {
    return {
      loadingTotalExpenses: true,
      loadingByAmount: true,
      loadingPayables: true,
      loadingCategoriesAmount: true,
      loadingRejecteds: true,
      loadingProjects: true,
      page: 1,
      projectsPerPage: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '15', value: 15 },
        { text: this.$t('general.all'), value: -1 }
      ],
      projectsToShow: 5,
      totalExpenses: {
        size: 0,
        total: 0
      },
      payables: {
        size: 0,
        total: 0
      },
      rejecteds: {
        size: 0,
        total: 0
      },
      byAmount: {
        total: 0
      },
      filterValue: 1,
      date: new Date().toISOString().substr(0, 4),
      slickOptions: {
        slidesToShow: 3,
        dots: false,
        infinite: false,
        slidesToScroll: 3
      },
      series: [],
      series2: [
        {
          name: '',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      series3: [0, 0, 0, 0, 0, 0],
      categoriesAmount: [],
      categories: [],
      amounts: [],
      colors: [
        'success',
        'danger',
        'info',
        'warning',
        'primary'
      ],
      colorsRGB: ['#3ac47d', '#d92550', '#3f6ad8', '#16aaff', '#f7b924', '#3f6ad8']
    }
  },
  watch: {
    '$store.state.userLogged' () {
      if (this.$store.state.userLogged.company[0] !== undefined) {
        this.get()
      }
    },
    filterValue () {
      this.get()
    },
    projectsToShow () {
      this.page = 1
    },
    categories (value) {
      if (value && this.$store.state.userLogged.company !== undefined) this.get()
    }
  },
  created () {
    this.initialize()
    // if (this.$store.state.userLogged.company !== undefined) {
    //   this.get()
    // }
  },
  computed: {
    chartOptions () {
      return {
        dataLabels: {
          enabled: false
        },
        chart: {
          height: 250,
          sparkline: {
            enabled: false
          }
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: this.months
        },
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topRight'
          }
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left'
        }
      }
    },
    chartOptions2 () {
      return {
        dataLabels: {
          enabled: false
        },
        chart: {
          height: 250,
          sparkline: {
            enabled: false
          }
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: this.months
        },
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topRight'
          }
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left'
        }
      }
    },
    chartOptions3 () {
      return {
        labels: this.chartOptions3Labels,
        colors: this.chartOptions3Colors,
        legend: {
          show: false
        },
        total: {
          show: true
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        }
      }
    },
    chartOptions3Labels () {
      let labels = []
      this.categories.forEach(element => {
        labels.push(element.name)
      })
      return labels
    },
    chartOptions3Colors () {
      let colors = []
      this.categories.forEach((element, index) => {
        let color = ''
        if (index > 5) {
          let offset = Math.ceil((index / 6) - 1)
          color = this.colorsRGB[offset]
        } else {
          color = this.colorsRGB[index]
        }
        colors.push(color)
      })
      return colors
    },
    filterSelected () {
      switch (this.filterValue) {
        case 1:
          return 'month'
        case 2:
          return 'quart'
        case 3:
          return 'year'
        default:
          return 'month'
      }
    },
    months () {
      return [
        this.$t('general.months.jan'),
        this.$t('general.months.feb'),
        this.$t('general.months.mar'),
        this.$t('general.months.apr'),
        this.$t('general.months.may'),
        this.$t('general.months.jun'),
        this.$t('general.months.jul'),
        this.$t('general.months.aug'),
        this.$t('general.months.sep'),
        this.$t('general.months.oct'),
        this.$t('general.months.nov'),
        this.$t('general.months.dec')
      ]
    },
    filterOptions () {
      return [
        {text: this.$t('dashboard.monthly'), value: 1},
        {text: this.$t('dashboard.quarter'), value: 2},
        {text: this.$t('dashboard.yearly'), value: 3}
      ]
    },
    projectsPages () {
      return Math.ceil(this.series.length / this.projectsToShow)
    },
    projectsSeries () {
      if (this.projectsToShow < 0) {
        return this.series
      } else {
        return this.series.slice(0 + ((this.page - 1) * this.projectsToShow), this.projectsToShow + ((this.page - 1) * this.projectsToShow))
      }
    },
    heading () {
      return this.$t('general.dashboard')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fa fa-home fa-fw icon-color'
    }
  },
  methods: {
    getFontSizeClass(value) {
      const digits = Math.floor(Math.abs(value)).toString().length
      
      switch (digits) {
        case 4: return 'small-font-d4'; break;
        case 5: return 'small-font-d5'; break;
        case 6: return 'small-font-d6'; break;
        case 7: return 'small-font-d7'; break;
        default: return '';
      }
    },
    catStyle (item) {
      switch (item) {
        case 1:
          return {
            icon: 'lnr-drop',
            color: 'success',
            name: this.$t('categories.ct.fuel')
          }
        case 2:
          return {
            icon: 'lnr-dinner',
            color: 'danger',
            name: this.$t('categories.ct.meals')
          }
        case 3:
          return {
            icon: 'lnr-apartment',
            color: 'info',
            name: this.$t('categories.ct.hotel')
          }
        case 4:
          return {
            icon: 'lnr-flag',
            color: 'warning',
            name: this.$t('categories.ct.tollGates')
          }
        case 5:
          return {
            icon: 'lnr-train',
            color: 'primary',
            name: this.$t('categories.ct.transportation')
          }
        case 6:
          return {
            icon: 'lnr-star',
            color: 'danger',
            name: this.$t('categories.ct.others')
          }
        default:
          return {
            icon: 'lnr-star',
            color: 'success',
            name: this.$t('categories.ct.fuel')
          }
      }
    },
    get () {
      this.loadingTotalExpenses = true
      this.loadingByAmount = true
      this.loadingPayables = true
      this.loadingCategoriesAmount = true
      this.loadingRejecteds = true
      this.loadingProjects = true
      this.$emit('getTotal', {filter: this.filterValue, date: this.date, context: this})
    },
    initialize () {
      this.$emit('initialize', { context: this })
    },
    getColorByIndex (index) {
      let idx = index % 5
      return idx === -1 ? this.colors[4] : this.colors[idx]
    }
  }
}
</script>

<style scoped>
.text-gray{
  color: rgba(0,0,0,.87) !important; 
}
.small-font-d4 {
  font-size: 30px !important;
}
.small-font-d5 {
  font-size: 25px !important;
}
.small-font-d6 {
  font-size: 18px !important;
}
.small-font-d7 {
  font-size: 15px !important;
}
.center-chart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/components/adminDashboard.component.vue